module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Black.aff1213.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Black.otf
// module id = Fveh
// module chunks = 0